import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["linkAs", "title"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import { Button } from 'semantic-ui-react';
var ELEMENT_PROPS = {
  Button: {
    primary: true
  }
};
var ELEMENT_TYPES = {
  span: /*#__PURE__*/React.createElement("span", null),
  p: /*#__PURE__*/React.createElement("p", null),
  // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
  a: /*#__PURE__*/React.createElement("a", null),
  Button: /*#__PURE__*/React.createElement(Button, null),
  h1: /*#__PURE__*/React.createElement("h1", null),
  h2: /*#__PURE__*/React.createElement("h2", null),
  h3: /*#__PURE__*/React.createElement("h3", null),
  h4: /*#__PURE__*/React.createElement("h4", null)
};
function getElementProps(linkAs) {
  return ELEMENT_PROPS[linkAs] || {};
}
function getLinkElement(linkAs) {
  return ELEMENT_TYPES[linkAs] || ELEMENT_TYPES.span;
}
export default function LinkContent(_ref) {
  var linkAs = _ref.linkAs,
    title = _ref.title,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.cloneElement(getLinkElement(linkAs), _objectSpread(_objectSpread({
    children: title
  }, getElementProps(linkAs)), rest));
}